var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favorite",on:{"click":_vm.onFavoriteClicked}},[_c('span',{staticClass:"text"},[_vm._v("Favorite")]),_vm._v(" "),(_vm.favorite)?_c('span',{staticClass:"af af-heart-full"}):_c('span',{staticClass:"af af-heart"})])}
var staticRenderFns = []

export { render, staticRenderFns }